var map = {
	"./about-us.svg": 767,
	"./betting-icon.svg": 768,
	"./bonus.svg": 769,
	"./coin.png": 770,
	"./contact-us.svg": 771,
	"./download-app.svg": 772,
	"./edit-btn.svg": 773,
	"./feedback.svg": 774,
	"./global.svg": 775,
	"./info-centre.svg": 776,
	"./instant-rebate.svg": 777,
	"./mall-icon.svg": 778,
	"./message.svg": 779,
	"./redemption-icon.svg": 780,
	"./referral.svg": 781,
	"./resp-gaming.svg": 782,
	"./security.svg": 783,
	"./transaction-icon.svg": 784,
	"./vip-icon.svg": 785,
	"./wallet-icon.svg": 786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;